import { useEffect, useState } from "react";
import { Dropdown, Button, Row, Col, Table, Space } from "antd";
import type { IComplementoBeneficio, SimpleDropdownItem } from "../../../components/Interfaces";
import { DeleteOutlined, PlusSquareFilled } from "@ant-design/icons";
import type { AlignType } from "rc-table/lib/interface";
import { hasPermissao, Papel } from "../../../components/auth/entidadeUsuario";


interface IProps {
  // planoRegulamentoDocumento: IDocumento[];
  // setPlanoRegulamentoDocumento: React.Dispatch<React.SetStateAction<IDocumento[]>>;
  // setTipoRegulamento: React.Dispatch<React.SetStateAction<number>>;
  // listTipoRegulamento: ISelectList[];
  items: SimpleDropdownItem[];
  tipo: number; // 1: Regra Cálculo / 2: Requisito Elegibilidade
  objetoTipo: IComplementoBeneficio[];
  setObjetoTipo: React.Dispatch<React.SetStateAction<IComplementoBeneficio[]>>;
  manter?: number; // 1 : Inserir / 2 : Consultar / 3 : Editar;
}

const BeneficioComplemento = ({ items, tipo, objetoTipo, setObjetoTipo, manter }: IProps) => {
  const [exibirComplementoCadastrado, setExibirComplementoCadastrado] = useState("none");

  useEffect(() => {
    if (objetoTipo.length === 0) {
      setExibirComplementoCadastrado("none")
    } else {
      setExibirComplementoCadastrado("inline")
    }
  }, [objetoTipo]);

  function gerarColunas() {
    let cols: any[] = [];

    cols.push(
      tipo === 2
        ? null
        :
        {
          title: "Parâmetros de Cálculos de Benefícios",
          dataIndex: "",
          render: (tipo: IComplementoBeneficio) => (
            items.find(l => l.key === tipo.tipoComplementoId)?.label
          )
        });

    cols.push(
      tipo === 1
        ? null
        :
        {
          title: "Requisitos de Eligibilidade",
          dataIndex: "",
          render: (tipo: IComplementoBeneficio) => (
            items.find(l => l.key === tipo.tipoComplementoId)?.label
          )
        });

    cols.push({
      width: 40,
      title: "Opções",
      dataIndex: "",
      align: 'center' as AlignType,
      render: (tipo: IComplementoBeneficio) => (
        <>
          <Space>
            <div style={{ display: manter !== 2 ? "inline" : "none" }}>
              <DeleteOutlined
                title="Excluir tipo ainda não gravado na base."
                style={{ color: "red", display: (!tipo?.id || tipo?.id === "") ? "inline" : "none" }} // EXCLUSÃO DE REGISTRO SENDO INSERIDO NO PROCESSO. OU SEJA. QUE AINDA NÃO ESTÁ NA BASE
                onClick={() => {
                  setObjetoTipo(objetoTipo.filter((obj) => obj !== tipo));
                }}
              />
            </div>

            <div style={{ display: (tipo?.id && tipo?.id !== "") && hasPermissao([Papel.DILIC_MASTER]) ? (manter !== 2 ? "inline" : "none") : "none" }}>
              <>
                <PlusSquareFilled
                  title="Desmarcar para exclução"
                  style={{ color: "blue", display: (tipo.marcadoParaExclusao) ? "inline" : "none" }}
                  onClick={() => {
                    tipo.marcadoParaExclusao = !tipo.marcadoParaExclusao; // INVERTE 
                    setObjetoTipo(pre => { //TROCA O REGISTRO DO DATASET PELO REGISTRO EM ALTERAÇÃO
                      return pre.map(t => {
                        if (t.id === tipo.id) {
                          return tipo;
                        } else {
                          return t;
                        }
                      });
                    });

                  }}
                />
              </>

              <>
                <DeleteOutlined
                  title="Marcar para exclução/inativação"
                  style={{ color: "red", display: (!tipo.marcadoParaExclusao) ? "inline" : "none" }}
                  onClick={() => {
                    tipo.marcadoParaExclusao = !tipo.marcadoParaExclusao; // INVERTE 
                    setObjetoTipo(pre => { //TROCA O REGISTRO DO DATASET PELO REGISTRO EM ALTERAÇÃO
                      return pre.map(t => {
                        if (t.id === tipo.id) {
                          return tipo;
                        } else {
                          return t;
                        }
                      });
                    });

                  }}
                />
              </>
            </div>
          </Space>
        </>
      ),

    });

    return cols.filter(Boolean);
  }
  const columns = gerarColunas();

  const menu = {
    items: items.map(i => ({
      key: i.key,
      label: i.label
    })),
    onClick: (info: { key: string }) => {
      const item = items.find(i => i.key === info.key);
      if (item) {
        setObjetoTipo((prev) => {
          // check if the id already exists
          if (prev.some((x) => x.id === info.key)) {
            return prev; // do nothing
          }

          return [
            ...prev,
            {
              id: "",
              nome: item.label?.toString() ?? "",
              tipoComplementoId: info.key,
              marcadoParaExclusao: false,
            }
          ];
        });
      }
    }
  };

  return (
    <>
      <Dropdown
        disabled={manter === 2 ? true : false}
        menu={menu} placement="bottomLeft"
      >
        <Button
          shape='round'
          type='primary'
        >
          {tipo === 1 ? "Incluir Parâmetro" : "Incluir Requisito"}
        </Button>
      </Dropdown>

      <Row style={{ display: exibirComplementoCadastrado }}>
        <Col
          xs={24}
          sm={24}
        >
          <Table
            size="small" rowKey="tipoComplementoId" columns={columns} dataSource={objetoTipo} pagination={false} />
        </Col>
      </Row>

    </>
  );
}

export default BeneficioComplemento;
